var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.tr.formSavedEmailLink)),_c('br'),_c('copy-text',{staticClass:"link",attrs:{"label":((_vm.tr.formLink) + ":"),"text":_vm.link}}),_vm._v(" "+_vm._s(_vm.tr.mayCloseOrContinue)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }